import styled from "styled-components";
import React, {css} from "react";

import theme from "../../../styles/theme";

const HamburgerButtonWrapper = styled.button`
  padding: 0;
  background: none;
  border: none;
`;

const HamburgerIcon = styled.div`
  display: block;
  position: relative;
  width: 25px;
  height: 25px;
`;

const Line = styled.div`
  width: 25px;
  height: 6px;
  background: ${() => theme.colors.green5};
  transition: 0.4s ease;
  transition-timing-function: cubic-bezier(0.75, 0, 0.29, 1.01);
  position: absolute;
`;

const TopLine = styled(Line)`
  top: 0;
  &.animate {
    top: 8px !important;
    transform: rotate(45deg);
  }
`;

const MidLine = styled(Line)`
  top: 8px;
  &.animate {
    opacity: 0;
  }
`;

const BotLine = styled(Line)`
  top: 16px;
  &.animate {
    top: 8px !important;
    transform: rotate(-225deg);
  }
`;

const Hamburger = ({ isOpen }) => (
  <HamburgerIcon>
    <TopLine className={isOpen ? "animate" : ""} />
    <MidLine className={isOpen ? "animate" : ""} />
    <BotLine className={isOpen ? "animate" : ""} />
  </HamburgerIcon>
);

const HamburgerButton = ({ isOpen, onClick, className }) => (
  <HamburgerButtonWrapper
    className={className}
    onClick={onClick}
    isOpen={isOpen}
  >
    <Hamburger isOpen={isOpen} />
  </HamburgerButtonWrapper>
);

export default HamburgerButton;
